import { type IqfAxiosError } from "iqf-web-ui/api-fetch";

/*
 * Backend vrací hlášku ve dvou jakostech. IqfExceptionProcessor posílá doménový kód
 * a text psaný pro uživatele, zatímco GeneralExceptionProcessor dá NO_CODE a syrové
 * throwable.getMessage() (Access Denied, chyba Jacksonu, obsah NPE) a
 * PersistenceExceptionProcessor jen "Persistence error". Ukazujeme proto jen tu první.
 */
const GENERIC_CODES = ["NO_CODE", "PERSISTENCE_ERROR"];

/** Hláška z backendu, pokud je psaná pro uživatele. Jinak undefined. */
export function domainErrorMessage(error: IqfAxiosError): string | undefined {
  const code = error.data?.code;
  const message = error.data?.message;

  if (!code || !message || GENERIC_CODES.includes(code)) {
    return undefined;
  }

  return message;
}
